import { router, useLocalSearchParams } from 'expo-router';

import { useUpdateNonProfitOrg } from '@/api/hooks/nonProfitOrgHooks';
import { NonProfitOrg } from '@/api/models/nonProfitOrgModels';
import NpoTotalSalariesForm from '@/components/forms/NpoTotalSalariesForm';
import { useAuth } from '@/contexts/authContext';
import { useEndFlowModal } from '@/contexts/endFlowModalContext';
import { TotalSalariesData } from '@/lib/validations/NpoOnboardingSchema';
import { i18n } from '@/utils/i18n';
import { safeJsonParse } from '@/utils/jsonParse';

const NpoTotalSalaries = () => {
  const { npoJson } = useLocalSearchParams<{ npoJson: string }>();
  const { state: authState } = useAuth();
  const { mutateAsync: nonProfitUpdate, isPending: nonProfitIsPending } = useUpdateNonProfitOrg();
  const { showError, showSuccess } = useEndFlowModal();

  const nonProfitOrg = safeJsonParse<NonProfitOrg>(npoJson ?? '');

  const onSubmit = async (data: TotalSalariesData) => {
    try {
      nonProfitUpdate(
        {
          npoId: authState.signUpData?.loginEmail?.npoId ?? '',
          totalSalaries: data.totalSalaries,
          totalEmployeeBeneficits: data.otherEmployeesBenefits
        },
        {
          onSuccess: () => {
            showSuccess({
              title: i18n.t('end_flow.success_title'),
              message: i18n.t('npo_details.update_message')
            });
            router.back();
          },
          onError: (e) => {
            showError({ message: e.message });
            console.error('Error', e);
          }
        }
      );
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <NpoTotalSalariesForm
      nonProfitOrg={nonProfitOrg}
      isLoading={nonProfitIsPending}
      showBackButton={false}
      showSaveAndContinueButton={false}
      submitLabel={i18n.t('mix.done')}
      onSubmitTapped={onSubmit}
    />
  );
};

export default NpoTotalSalaries;
